var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('avp-breadcrumbs'), _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('avp-date-picker', {
    attrs: {
      "label": "Data Início da Verba",
      "cols": "3"
    },
    model: {
      value: _vm.form.filters.dataInicioVerba,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicioVerba", $$v);
      },
      expression: "form.filters.dataInicioVerba"
    }
  }), _c('avp-date-picker', {
    attrs: {
      "label": "Data Fim da Verba",
      "cols": "3"
    },
    model: {
      value: _vm.form.filters.dataFimVerba,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFimVerba", $$v);
      },
      expression: "form.filters.dataFimVerba"
    }
  }), _c('avp-select-ativo', {
    attrs: {
      "cols": 2
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('avp-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarVerbaPagamento();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterVerbaPagamento();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listVerbaPagamentos,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.dataInicioVerba`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm._f("date")(item.dataInicioVerba, true)) + " ")];
      }
    }, {
      key: `item.dataFimVerba`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm._f("date")(item.dataFimVerba ? item.dataFimVerba : 'Não Possui', true)) + " ")];
      }
    }, {
      key: `item.verba`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.verba) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('avp-label-ativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('avp-tooltip', {
          attrs: {
            "text": 'Editar Verba de Pagamento',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterVerbaPagamento(item);
            }
          }
        }), _c('avp-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'} Verba de Pagamento`,
            "icon": `${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarVerbaPagamento(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarVerbaPagamentoDialog', {
    attrs: {
      "visible": _vm.dialogManterVerbaPagamento.visible,
      "content": _vm.dialogManterVerbaPagamento.content,
      "edit": _vm.dialogManterVerbaPagamento.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterVerbaPagamento.close();
      },
      "onSave": function ($event) {
        return _vm.buscarVerbaPagamento();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }